import React from "react";
import { useNavigate } from "react-router-dom";

const User = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    alert("로그아웃 되었습니다!");
    navigate("/");
  };

  return (
    <div style={{ padding: "40px 20px", maxWidth: "400px", margin: "0 auto", textAlign: "center" }}>
      <h2 style={{ marginBottom: "20px", color: "#333" }}>내 정보</h2>
      
      <div style={{ 
        padding: "20px", 
        border: "1px solid #ddd", 
        borderRadius: "10px", 
        backgroundColor: "white",
        marginBottom: "30px"
      }}>
        <p style={{ color: "#666", margin: 0 }}>현재 로그인 중입니다.</p>
        {/* 추후 여기에 닉네임이나 이메일을 보여줄 수 있어요 */}
      </div>

      <button
        onClick={handleLogout}
        style={{
          width: "100%",
          padding: "12px",
          backgroundColor: "#ff6b6b", 
          color: "white",
          border: "none",
          borderRadius: "8px",
          fontSize: "1rem",
          fontWeight: "bold",
          cursor: "pointer",
          transition: "background 0.2s"
        }}
      >
        로그아웃
      </button>
      
      <button 
        onClick={() => navigate(-1)}
        style={{
          marginTop: "15px",
          background: "none",
          border: "none",
          color: "#999",
          cursor: "pointer",
          textDecoration: "underline"
        }}
      >
        돌아가기
      </button>
    </div>
  );
};

export default User;